import {
  UpdateUserAttributeOutput,
  updateUserAttribute,
} from "aws-amplify/auth";

import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updatePhoneNumber = async ({
  phoneNumber,
}: {
  phoneNumber: string;
}): Promise<UpdateUserAttributeOutput> => {
  const response = await updateUserAttribute({
    userAttribute: {
      attributeKey: "phone_number",
      value: phoneNumber,
    },
  });

  return response;
};

function useUpdatePhoneNumber(
  mutationOptions?: UseMutationOptions<
    UpdateUserAttributeOutput,
    HttpError,
    { phoneNumber: string }
  >,
) {
  return useMutation({
    mutationFn: updatePhoneNumber,
    ...mutationOptions,
  });
}

export { useUpdatePhoneNumber };
